import { Vector3 } from 'three';
import { AttachmentAsset } from '../../models/standard/AttachmentAsset';
import AttachmentModel, { AttachmentType } from '../../models/standard/AttachmentModel';
import AttributeModel from '../../models/standard/AttributeModel';
import HotspotModel from '../../models/standard/HotspotModel';

export default async function deserializeHotspot(h: any): Promise<HotspotModel> {
  const pos = new Vector3(h.position.x, h.position.y, h.position.z);
  
  let attachment: AttachmentModel;
  const type = h.attachment.type as AttachmentType;
  const rawData = h.attachment.data;


  if (type === AttachmentType.ATTRIBUTE) {
    const attribute = new AttributeModel(
      rawData.id,
      rawData.key,
      rawData.value,
      rawData.predecessorId,
      rawData.type,
      rawData.unit,
      rawData.hidden,
      rawData.forced,
      // --- Pass extended properties to prevent data loss ---
      rawData.ownerId,
      rawData.userId,
      rawData.publicFlag,
      rawData.localization,
      rawData.defaults,
      rawData.validation,
      rawData.unitFamily
    );
    
    attachment = new AttachmentModel(AttachmentType.ATTRIBUTE, attribute);
  } else {
    const assetData = rawData as AttachmentAsset;
    
    attachment = new AttachmentModel(type, assetData);
  }

  if (h.attachment.uuid) {
    attachment.setUUID(h.attachment.uuid);
  }

  const hotspot = new HotspotModel(
    h.id, 
    pos, 
    attachment, 
    new Date(h.creationDate), 
    h.userId
  );

  if (h.uuid) {
    hotspot.setUUID(h.uuid);
  }

  return hotspot;
}